import React from 'react'

export default () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
		<g fill="none" fillRule="evenodd">
			<circle cx="15" cy="15" r="15" fill="#233448" />
			<path fill="#FFF" d="M14.474 20.107L8.036 13.77a.74.74 0 0 1 0-1.055.764.764 0 0 1 1.071 0l5.893 5.8 5.893-5.8a.764.764 0 0 1 1.071 0 .74.74 0 0 1 0 1.055l-6.438 6.337a.75.75 0 0 1-1.052 0z" />
		</g>
	</svg>
)
